module.exports = __webpack_public_path__ + "img/loading-error.257f9219.png";